import {
  CLOSED_PERIODS_ADMIN_GET_LIST_INIT,
  CLOSED_PERIODS_ADMIN_GET_LIST_SUCCESS,
  CLOSED_PERIODS_ADMIN_GET_LIST_FAILURE,
  CLOSED_PERIODS_ADMIN_SAVE_INIT,
  CLOSED_PERIODS_ADMIN_SAVE_SUCCESS,
  CLOSED_PERIODS_ADMIN_SAVE_FAILURE,
  CLOSED_PERIODS_ADMIN_SET_SAVE_DATA_BY_KEY,
  CLOSED_PERIODS_ADMIN_SAVE_RESET,
	CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_INIT,
	CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS,
	CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE,
	CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT,
	CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS,
	CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE,
  CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT,
  CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS,
  CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE,
  CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_INIT,
  CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_SUCCESS,
  CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_FAILURE,
  CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_INIT,
  CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_SUCCESS,
  CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_FAILURE,
  CLOSED_PERIODS_ADMIN_DELETE_PREPARE_INIT,
  CLOSED_PERIODS_ADMIN_DELETE_INIT,
  CLOSED_PERIODS_ADMIN_DELETE_SUCCESS,
  CLOSED_PERIODS_ADMIN_DELETE_FAILURE,
  CLOSED_PERIODS_GET_CUSTOMER_INIT,
  CLOSED_PERIODS_GET_CUSTOMER_SUCCESS,
  CLOSED_PERIODS_GET_CUSTOMER_FAILURE,
  CLOSED_PERIODS_ADMIN_RESET
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import Constants from '../../../definitions/constants';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: CLOSED_PERIODS_ADMIN_RESET
  };
}

export function rollBackPeriod(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/rollbackperiod",
        "PUT",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_FAILURE, error));
    }  
  };
}

export function prepareDeleteEntity(id) {
  return {
    type: CLOSED_PERIODS_ADMIN_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CLOSED_PERIODS_ADMIN_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/delete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_DELETE_FAILURE, error));
    }  
  };
}

export function getList(params, paging = false) {
  let forceParams = {
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC]
  };
  let newParams = Object.assign({}, params, forceParams)
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: CLOSED_PERIODS_ADMIN_GET_LIST_INIT,
      params: newParams,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        newParams
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_GET_LIST_FAILURE, error));
    }  
  };
}

export function saveEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CLOSED_PERIODS_ADMIN_SAVE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/save",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_SAVE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_SAVE_FAILURE, error));
    }  
  };
}

export function setSaveEntityDataByKey(key, value) {
  return {
    type: CLOSED_PERIODS_ADMIN_SET_SAVE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveEntity(data) {
  return {
    type: CLOSED_PERIODS_ADMIN_SAVE_RESET,
    data: data 
  };
}

export function getCalculationsHistory(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/calculations_history",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE, error));
    }  
  };
}

export function downloadCalculationReportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/downloadcalculationreportfile",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE, error));
    }  
  };
}

export function downloadCalculationUnifiedReportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculation/downloadcalculationunifiedreportfile",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE, error));
    }  
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: [],
    searches_are: [],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function getCustomer() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(CLOSED_PERIODS_GET_CUSTOMER_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/getcustomer",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(CLOSED_PERIODS_GET_CUSTOMER_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(CLOSED_PERIODS_GET_CUSTOMER_FAILURE, error));
    }  
  }
}



// WEBPACK FOOTER //
// ./source/client/actions/closedPeriodsAdmin/index.js